import React from 'react';
import styled from 'styled-components';

const LogoTextStyles = styled.span`
  font-family: coquette, sans-serif;
  font-weight: 400;
  font-style: normal;
  font-size: 120%;
  line-height: 1;
`;

const LogoText = () => (
  <LogoTextStyles className="logoText">bora saxofoonkwartet</LogoTextStyles>
);

export default LogoText;
